import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import Header from "../components/header.js";
import SearchBar from "../components/search/searchbar.js";
import Hospitals from "../components/search/hospitals.js";
import { AEYDAR_API } from "../constants.js";

const Search = () => {
  const parameter = useParams();
  const [loading, setLoading] = useState(false);
  const [hospitals, setHospitals] = useState([]);
  const [keyword, setKeyword] = useState(parameter.search || "");

  const handleKeywordChange = (event) => {
    setKeyword(event.target.value);
  };

  const getHospitals = async () => {
    let geocode = await getUserLocation();
    setLoading(true);
    setHospitals([]);
    let lat = geocode?.lat;
    let lon = geocode?.lon;
    const response = await fetch(
      `${AEYDAR_API}/geocode/${keyword || " "}/${lat || "null"}/${
        lon || "null"
      }`
    ).catch((error) => {
      setLoading(false);
      console.error(error);
    });

    if (response) {
      setLoading(false);
    }

    const hospitals = await response?.json();
    if (hospitals) {
      setHospitals(hospitals);
    }
  };

  const getUserLocation = async () => {
    if (!navigator.geolocation) {
      alert("no geolocation support");
      return;
    }

    const currentPosition = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        maximumAge: 0,
        enableHighAccuracy: true,
      });
    }).catch((error) => {
      alert(error.message);
    });
    if (!currentPosition) {
      return {};
    }

    //return this
    const { latitude, longitude } = currentPosition.coords;
    return { lat: latitude, lon: longitude };
  };

  useEffect(
    () => {
      getHospitals();
    },
    // eslint-disable-next-line
    []
  );

  return (
    <>
      <Header />
      <SearchBar
        getGeoCode={getHospitals}
        keywordChange={handleKeywordChange}
        search={parameter.search}
      />
      <Hospitals hospitals={hospitals} loading={loading} />
    </>
  );
};

export default Search;
